export const categories = {
    ACCOM: '숙소',
    FOOD: '음식',
    TOUR: '관광',
    ETC: '기타',
    MEMO: 'memo'
}
